module.exports = __webpack_public_path__ + "static/media/ic-kid-girl.57538695.svg";